<template>
    <div class="order-success-container">
        <div class="content-box">
            <!-- 1. 成功图标 -->
            <div class="icon-wrapper">
                <i class="el-icon-check"></i>
            </div>

            <!-- 2. 标题 -->
            <h1 class="success-title">The order has been successfully submitted</h1>

            <!-- 3. 描述文本 -->
            <p class="success-desc">
                Objectively scale orthogonal collaboration and idea-sharing after enterprise-wide manufactured products.
                Compellingly strategize high-quality niche markets through sustainable.
            </p>

            <!-- 4. 按钮区域 -->
            <div class="action-area">
                <el-button type="primary" class="btn-view-details" @click="handleViewDetails">
                    VIEW DETAILS
                </el-button>

                <div class="link-continue" @click="handleContinue">
                    CONTINUE SHOPPING
                </div>
            </div>
        </div>
        <OrderInfo :visible="visible" @closeHandler="handleClose" :orderId="orderId" />
    </div>
</template>

<script>
import OrderInfo from '@/components/orderInfo.vue'
export default {
    name: "OrderSuccess",
    components: {
        OrderInfo
    },
    data() {
        return {
            visible: false,
            orderId: ''
        }
    },
    methods: {
        handleViewDetails() {
            this.visible = true
            this.orderId = this.$route.query.orderId || ''

        },
        handleClose() {
            this.visible = false
        },
        handleContinue() {
            // 继续购物逻辑
            this.$router.push({ path: '/member/productCenter' })
        }
    }
};
</script>

<style lang="scss" scoped>
.order-success-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 90vh;
    /* 让内容垂直居中，可根据实际情况调整 */
    background-color: #FAF9F7;
    font-family: "NotoSerif", sans-serif;
    /* 匹配截图的衬线体风格 */
    color: #333;
}

.content-box {
    text-align: center;
    max-width: 800px;
    padding: 20px;
    margin-bottom: 100px;
}

/* 图标样式 */
.icon-wrapper {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    background-color: #64c42d;
    /* 鲜艳的绿色 */
    border-radius: 50%;
    box-shadow: 0 4px 10px rgba(100, 196, 45, 0.3);
    margin-bottom: 30px;

    i {
        color: #fff;
        font-size: 32px;
        font-weight: bold;
    }
}

/* 标题样式 */
.success-title {
    font-size: 28px;
    font-weight: normal;
    margin-bottom: 20px;
    color: #222;
    letter-spacing: 0.5px;
}

/* 描述文本样式 */
.success-desc {
    font-family: "NotoSerif", sans-serif;
    font-size: 14px;
    line-height: 1.6;
    color: rgba(0, 0, 0, 0.45);
    margin-bottom: 40px;
    padding: 0 40px;
}

/* 按钮区域 */
.action-area {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.btn-view-details {
    background-color: #4e433d;
    /* 深褐色 */
    border-color: #4e433d;
    border-radius: 4px;
    padding: 12px 40px;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-family: "NotoSerif", sans-serif;
    transition: opacity 0.3s;

    &:hover,
    &:focus {
        background-color: #63564f;
        border-color: #63564f;
        opacity: 0.9;
    }
}

/* 底部链接样式 */
.link-continue {
    margin-top: 20px;
    font-size: 12px;
    color: #333;
    text-decoration: underline;
    text-transform: uppercase;
    cursor: pointer;
    letter-spacing: 1px;
    font-family: "NotoSerif", sans-serif;

    &:hover {
        color: #000;
    }
}

/* 移动端适配 */
@media (max-width: 768px) {
    .success-desc {
        padding: 0 10px;
    }

    .success-title {
        font-size: 24px;
    }
}
</style>